import { INFO_POPUP_TYPE, InfoPopup, useMessageContext } from '@apeiron/temp'
import { styled, Typography } from '@mui/material'
import GuildJoined from '@src/components/guild/change/GuildJoined'
import GuildSelectList from '@src/components/guild/change/GuildSelectList'
import { useGuildChangeContext } from '@src/contexts/guild/GuildChangeContext'
import { Guild } from '@src/types/guild'
import * as R from 'ramda'
import { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const Popup = styled(InfoPopup)`
  width: 95%;
  height: 95%;
  max-height: 650px;
  max-width: 720px;
  .Custom-Content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    justify-content: flex-start;
    margin-top: -30px;
    padding: 0px 30px;
    width: 100%;
  }
`

const Title = styled(Typography)`
  font-size: 24px;
  font-weight: 500;
  margin-left: 2px;
`

const Remark = styled(Typography)`
  color: #908f90;
  font-size: 14px;
  font-weight: 300;
  line-height: 26px;
  margin-left: 4px;
  white-space: pre-line;
`

const GuildList = styled(GuildSelectList)`
  flex: 1;
  margin-top: 10px;
`

const GuildChangePopup: FC<Props> = (props: Props) => {
  const { className, onGuildChanged } = props

  const { guildType, changeGuild, selectedGuild, setGuildType } =
    useGuildChangeContext()

  const { setInfo } = useMessageContext()

  const { t } = useTranslation()

  const handleOnClose = useCallback(() => {
    setGuildType(null)
  }, [setGuildType])

  const handleOnSuccess = useCallback(() => {
    setInfo(null)
    handleOnClose()
  }, [handleOnClose, setInfo])

  const handleOnConfirm = useCallback(async () => {
    const success = await changeGuild()

    if (success && !R.isNil(selectedGuild)) {
      setInfo({
        title: t('guild.change_success', { name: selectedGuild.name }),
        confirm: t('common.button.ok'),
        onConfirm: handleOnSuccess
      })
      if (onGuildChanged) {
        onGuildChanged(selectedGuild)
      }
    }
  }, [changeGuild, handleOnSuccess, onGuildChanged, selectedGuild, setInfo, t])

  const showPopup = R.isNotNil(guildType)

  return (
    <Popup
      className={className}
      open={showPopup}
      onClose={handleOnClose}
      type={INFO_POPUP_TYPE.BLACK}
    >
      <Title>{t('guild.change')}</Title>
      <GuildJoined />
      <Remark>{t('guild.cannot_change_in_24hr')}</Remark>
      <GuildList onConfirm={handleOnConfirm} />
    </Popup>
  )
}

type Props = {
  className?: string
  onGuildChanged?: (newGuild: Guild) => void
}

export default GuildChangePopup
